import React from 'react'
import './Works.css'
import Bf from '../../assets/Bf.jpeg'
import CC from '../../assets/CC.jpeg'
import PE from '../../assets/PE.jpg'

const Works = () => {
  return (
    <section id='works'>
        <h2 className='workstitle'>Sponsors</h2>
        <span className='worksDesc'>Our hackathon thrives on the support of visionary sponsors, powering innovation, fostering collaboration, and turning ideas into reality. Join us!</span>
        <div className='worksImgs'>
            <img src={Bf} alt=' ' className='worksImg'></img>
            <img src={CC} alt=' ' className='worksImg'></img>
            <img src={PE} alt=' ' className='worksImg'></img>
        </div>

    </section>
  )
}

export default Works
